// extracted by mini-css-extract-plugin
export var buttons = "modal-module--buttons--STpla";
export var close = "modal-module--close--NfP8z";
export var fixed = "modal-module--fixed--dQYEu";
export var fromRight = "modal-module--fromRight--lidEi";
export var fullHeight = "modal-module--fullHeight--zNX-n";
export var isClosing = "modal-module--isClosing--0kBFt";
export var modal = "modal-module--modal--GgTro";
export var modalContent = "modal-module--modalContent--whT3H";
export var root = "modal-module--root--RAiCj";
export var success = "modal-module--success--pej8-";
export var title = "modal-module--title--BcOLO";
export var toRight = "modal-module--toRight--+9yl9";